@if (loading) {
  <app-loading-indicator></app-loading-indicator>
} @else {
  @if (overlayService.overlayCard.getValue()?.title) {
    <div class="scores-title">
      {{ appStringAPI.getAppString(overlayService.overlayCard.getValue()!.title!) }}
    </div>
  }
  <!-- <app-tournament-search-card (search_event)="update_search_entry($event)" [should_disable]="false"></app-tournament-search-card> -->
  <div class="search-input">
    <mat-form-field>
      <mat-icon matPrefix>search</mat-icon>
      <mat-label>Search</mat-label>
      <input matInput [formControl]="search" />
      <button (click)="removeSearch()" mat-icon-button matSuffix><mat-icon>close</mat-icon></button>
    </mat-form-field>
  </div>
  <div
    style="overflow: auto; height: 100%"
        [class]="
            'scroll-section ' +
            handleCdkPane(
                entries.live | SearchFilterPipe : search.value,
                entries.past | SearchFilterPipe : search.value,
                entries.past_partner_events | SearchFilterPipe : search.value,
                entries.upcoming | SearchFilterPipe : search.value
            )
        "
    >
    @if (entries.live | SearchFilterPipe : search.value; as results) {
      <div class="tournament-collection">
        @if (results.length > 0) {
          <div class="label">{{ appStringAPI.getAppString('tennisone.scores.section.header.live.title') }}</div>
          @for (entry of entries.live | SearchFilterPipe : search.value; track entry) {
            <div
              [style]="handleBackground(entry.image_url)"
              class="tournament-item"
              (click)="updateTourSession(entry)"
              >
              <app-scheduled-entry [entry]="entry" [format]="'search_list'"></app-scheduled-entry>
            </div>
          }
        }
        <!-- <mat-optgroup [label]="appStringAPI.getAppString('tennisone.scores.section.header.live.title')" *ngIf="results.length > 0">
        <mat-option *ngFor="let entry of entries.live | SearchFilterPipe : search.value" [style]="handleBackground(entry.image_url)">
          <app-scheduled-entry (click)="updateTourSession(entry)" [entry]="entry" [format]="'search_list'"></app-scheduled-entry>
        </mat-option>
      </mat-optgroup> -->
    </div>
  }
  @if (entries.upcoming | SearchFilterPipe : search.value; as results) {
    <div class="tournament-collection">
      @if (results.length > 0) {
        <div class="label">{{ appStringAPI.getAppString('tennisone.scores.section.header.upcoming.title') }}</div>
        @for (entry of entries.upcoming | SearchFilterPipe : search.value; track entry) {
          <div
            [style]="handleBackground(entry.image_url)"
            class="tournament-item"
            (click)="updateTourSession(entry)"
            >
            <app-scheduled-entry [entry]="entry" [format]="'search_list'"></app-scheduled-entry>
          </div>
        }
      }
      <!-- <mat-optgroup [label]="appStringAPI.getAppString('tennisone.scores.section.header.upcoming.title')" *ngIf="results.length > 0">
      <mat-option *ngFor="let entry of entries.upcoming | SearchFilterPipe : search.value" [style]="handleBackground(entry.image_url)">
        <app-scheduled-entry (click)="updateTourSession(entry)" [entry]="entry" [format]="'search_list'"></app-scheduled-entry>
      </mat-option>
    </mat-optgroup> -->
  </div>
}
<!-- <div *ngIf="entries.past_partner_events | SearchFilterPipe : search.value as results">
<mat-optgroup [label]="appStringAPI.getAppString('tennisone.scores.section.header.completed.elite.title')" *ngIf="results.length > 0">
  <mat-option *ngFor="let entry of entries.past_partner_events | SearchFilterPipe : search.value" [style]="handleBackground(entry.image_url)">
    <app-scheduled-entry (click)="updateTourSession(entry)" [entry]="entry" [format]="'search_list'"></app-scheduled-entry>
  </mat-option>
</mat-optgroup>
</div> -->
@if (entries.past | SearchFilterPipe : search.value; as results) {
  <div class="tournament-collection">
    @if (results.length > 0) {
      <div class="label">{{ appStringAPI.getAppString('tennisone.scores.section.header.completed.title') }}</div>
      @for (entry of entries.past | SearchFilterPipe : search.value; track entry) {
        <div
          [style]="handleBackground(entry.image_url)"
          class="tournament-item"
          (click)="updateTourSession(entry)"
          >
          <app-scheduled-entry [entry]="entry" [format]="'search_list'"></app-scheduled-entry>
        </div>
      }
    }
    <!-- <mat-optgroup [label]="appStringAPI.getAppString('tennisone.scores.section.header.completed.title')" *ngIf="results.length > 0">
    <mat-option *ngFor="let entry of entries.past | SearchFilterPipe : search.value" [style]="handleBackground(entry.image_url)">
      <app-scheduled-entry (click)="updateTourSession(entry)" [entry]="entry" [routerLink]="entry.id" [format]="'search_list'"></app-scheduled-entry>
    </mat-option>
  </mat-optgroup> -->
</div>
}
@if (handleCdkPane(
  entries.live | SearchFilterPipe : search.value,
  entries.past | SearchFilterPipe : search.value,
  entries.past_partner_events | SearchFilterPipe : search.value,
  entries.upcoming | SearchFilterPipe : search.value
  ) === 'no-results-panel') {
  <mat-option
    class="static-no-results"
            [class]="
                handleNoResults(
                    entries.live | SearchFilterPipe : search.value,
                    entries.past | SearchFilterPipe : search.value,
                    entries.past_partner_events | SearchFilterPipe : search.value,
                    entries.upcoming | SearchFilterPipe : search.value
                )
            "
    disabled="true"
    >
    {{ appStringAPI.getAppString('tennisone.scores.search.no.results') }}
    </mat-option
    >
  }
</div>
}

